import React, { useEffect } from 'react'; 
import { Link } from "react-router-dom"; 
import Header from'../Component/Header'
const ContactUs = () => { 
    useEffect(() => {
        document.title = 'Contact Us - St. Josephs School Quadian Punjab';  
    }, []);    
    return (
        <> 
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Contact Us</li>
                </ul>
            </div> 
            <div className="innersec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2>Contact Us</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">  
                            <div className="formbox">
                               <div class="formboxleft">
                                     
                                    <div class="addressdesc">
                                        <div class="addressimg"> <i class="bi bi-geo-alt-fill"></i></div>
                                        <Link to="https://maps.app.goo.gl/8dqefciqntnrbccv6" target="_blank"> 
                                        
St. Joseph's School Quadian Punjab   </Link>
                                    </div>
                                    <div class="addressdesc">
                                        <div class="addressimg"><i class="bi bi-envelope-fill"></i></div>
                                        <Link to="mailto:stjosephconventschoolqadian@gmail.com"> stjosephconventschoolqadian@gmail.com</Link>  
                                    </div>
                                        <div class="addressdesc">
                                            <div class="addressimg"><i class="bi bi-telephone-fill"></i></div>
                                            <Link to="tel:91-9876414190">  91-9876414190</Link> 
                                        </div>
                                </div>
                                <div className="formboxright"> 
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d27125.205105774312!2d75.357448!3d31.80727!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391bbf6e16fe5a35%3A0xce8b5c07c7c65ad9!2sSt%20Joseph%20Convent%20School!5e0!3m2!1sen!2sin!4v1753946040685!5m2!1sen!2sin" width="100%" height="300" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                              </div>
                            </div> 
                        </div>
                    </div> 
                </div>
            </div>
        </>
    );
}

export default ContactUs;
